import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'BILLING_ACTIVITY';

export const {action: showingTargetId} = createAction(`${domain}/SHOWING_TARGET_ID`, targetId => ({targetId}));

export const {
    action: fetchBillPayersForFilter,
    success: fetchBillPayersForFilterSuccess,
    failed: fetchBillPayersForFilterFailed,
    aborted: fetchBillPayersForFilterAborted,
} = createAction(`${domain}/FETCH_BILL_PAYERS_FOR_FILTER`, (term, institutionId, organizationId) => ({
    term,
    institutionId,
    organizationId,
}));
export const {action: selectBillPayers} = createAction(`${domain}/SELECT_BILL_PAYER`, selectedBillPayers => ({
    selectedBillPayers,
}));

export const {
    action: fetchPayments,
    success: fetchPaymentsSuccess,
    failed: fetchPaymentsFailed,
} = createAction(
    `${domain}/FETCH_PAYMENTS_FOR_TARGET`,
    (
        targetId,
        offset,
        limit,
        from,
        to,
        confirmedFilter,
        paymentMethod,
        deposited,
        transactionStatus,
        createdAtFrom,
        createdAtTo,
        includeDeleted,
        billPayerIds,
        sortBy,
        sortAscending,
    ) => ({
        targetId,
        offset,
        limit,
        from,
        to,
        confirmedFilter,
        paymentMethod,
        deposited,
        transactionStatus,
        createdAtFrom,
        createdAtTo,
        includeDeleted,
        billPayerIds,
        sortBy,
        sortAscending,
    }),
);

export const {
    action: fetchInvoices,
    success: fetchInvoicesSuccess,
    failed: fetchInvoicesFailed,
} = createAction(
    `${domain}/FETCH_INVOICES_FOR_TARGET`,
    (targetId, offset, limit, from, to, createdAtFrom, createdAtTo, billPayerIds) => ({
        targetId,
        offset,
        limit,
        from,
        to,
        createdAtFrom,
        createdAtTo,
        billPayerIds,
    }),
);

export const {
    action: fetchDeposits,
    success: fetchDepositsSuccess,
    failed: fetchDepositsFailed,
} = createAction(`${domain}/FETCH_DEPOSITS_FOR_INSTITUTION`, institutionId => ({institutionId}));

export const {
    action: fetchSearchItems,
    success: fetchSearchItemsSuccess,
    failed: fetchSearchItemsFailed,
} = createAction(`${domain}/FETCH_SEARCH_ITEMS`, (term, institutionId, organizationId) => ({
    term,
    institutionId,
    organizationId,
}));

export const {
    action: fetchDirectDebitFiles,
    success: fetchDirectDebitFilesSuccess,
    failed: fetchDirectDebitFilesFailed,
} = createAction(
    `${domain}/FETCH_DIRECT_DEBIT_FILES`,
    ({institutionId, organizationId}) => ({institutionId, organizationId}),
    response => ({response}),
);

export const {
    action: makeDirectDebitRun,
    success: makeDirectDebitRunSuccess,
    failed: makeDirectDebitRunFailed,
} = createAction(
    `${domain}/MAKE_DIRECT_DEBIT_RUN`,
    ({institutionId, organizationId, paymentDate, filetype}) => {
        return {
            institutionId,
            organizationId,
            paymentDate,
            filetype,
        };
    },
    response => ({response}),
);

export const {
    action: makeDirectCreditRun,
    success: makeDirectCreditRunSuccess,
    failed: makeDirectCreditRunFailed,
} = createAction(
    `${domain}/MAKE_DIRECT_CREDIT_RUN`,
    ({institutionId, organizationId, paymentDate}) => {
        return {
            institutionId,
            organizationId,
            paymentDate,
        };
    },
    response => ({response}),
);

export const {action: selectionChanged} = createAction(`${domain}/SELECTION_CHANGED`, selection => ({selection}));

export const {action: confirmedStatusChanged} = createAction(`${domain}/CONFIRMED_FILTER_CHANGED`, status => ({
    status,
}));

export const {action: paymentMethodChanged} = createAction(`${domain}/PAYMENT_METHOD_CHANGED`, method => ({method}));

export const {action: depositStatusChanged} = createAction(`${domain}/DEPOSIT_METHOD_CHANGED`, method => ({method}));

export const {action: showArchivedBillPayersChanged} = createAction(
    `${domain}/SHOW_ARCHIVED_BILL_PAYERS_CHANGED`,
    show => ({show}),
);

export const {action: periodChanged} = createAction(`${domain}/PERIOD_CHANGED`, (from, to) => ({from, to}));

export const {action: createdAtPeriodChanged} = createAction(`${domain}/CREATED_AT_PERIOD_CHANGED`, (from, to) => ({
    from,
    to,
}));

export const {action: dateChanged} = createAction(`${domain}/DATE_CHANGED`, selectedDate => ({selectedDate}));

export const {action: directDebitSelectionChanged} = createAction(
    `${domain}/DIRECT_DEBIT_SELECTION_CHANGED`,
    selection => ({selection}),
);

export const {action: toggleDirectDebitInvoiceCheck} = createAction(
    `${domain}/TOGGLE_DIRECT_DEBIT_INVOICE_CHECK`,
    invoiceId => ({invoiceId}),
);

export const {action: showDirectDebitModal} = createAction(`${domain}/SHOW_DIRECT_DEBIT_MODAL`);
export const {action: showDirectCreditModal} = createAction(`${domain}/SHOW_DIRECT_CREDIT_MODAL`);

export const {action: hideDirectDebitModal} = createAction(`${domain}/HIDE_DIRECT_DEBIT_MODAL`);
export const {action: hideDirectCreditModal} = createAction(`${domain}/HIDE_DIRECT_CREDIT_MODAL`);

export const {action: transactionStatusChanged} = createAction(
    `${domain}/TRANSACTION_STATUS_CHANGED`,
    transactionStatus => ({transactionStatus}),
);

export const {action: onlyBillPayersWithMissingAddressChanged} = createAction(
    `${domain}/ONLY_BILL_PAYERS_WITH_MISSING_ADDRESS_CHANGED`,
    onlyBillPayersWithMissingAddress => ({
        onlyBillPayersWithMissingAddress,
    }),
);

export const {action: includeCreditNotesAndCancelledInvoicesInBalanceChanged} = createAction(
    `${domain}/INCLUDE_CREDITNOTES_AND_CANCELLED_INVOICES_IN_BALANCES_CHANGED`,
    includeCreditNotesAndCancelledInvoicesInBalance => ({
        includeCreditNotesAndCancelledInvoicesInBalance,
    }),
);

export const {action: includeDeletedPaymentsChanged} = createAction(
    `${domain}/INCLUDE_DELETED_PAYMENTS_CHANGED`,
    includeDeletedPayments => ({includeDeletedPayments}),
);

export const {action: toggleFilters} = createAction(`${domain}/TOGGLE_FILTERS`, () => ({}));

export const {action: setPaymentSourceTypeFilterValues} = createAction(
    `${domain}/SET_PAYMENT_SOURCE_TYPE_FILTER_VALUES`,
    newPaymentSourceTypeFilterValues => ({
        newPaymentSourceTypeFilterValues,
    }),
);

export const {action: setInvoiceSelected} = createAction(
    `${domain}/SET_INVOICE_SELECTED`,
    ({invoiceId, isSelected}) => ({invoiceId, isSelected}),
);

export const {action: selectAllInvoices} = createAction(`${domain}/SELECT_ALL_INVOICES`, selectedInvoices => ({
    selectedInvoices,
}));

export const {
    action: bulkCancelInvoices,
    success: bulkCancelInvoicesSuccess,
    failed: bulkCancelInvoicesFailed,
} = createAction(`${domain}/BULK_CANCEL_INVOICES`, ({invoices, notify, creditNoteDate}) => ({
    invoices,
    notify,
    creditNoteDate,
}));

export const {action: didCancelInvoice} = createAction(`${domain}/DID_CANCEL_INVOICE`, () => ({}));
export const {action: resetCancelInvoice} = createAction(`${domain}/RESET_CANCEL_INVOICE`, () => ({}));
export const {action: setShowBulkCancelInvoiceModal} = createAction(
    `${domain}/SET_SHOW_BULK_CANCEL_INVOICE_MODAL`,
    show => ({show}),
);
